import _ from 'lodash';
import { FETCH_FOLLOWING_SUCCESS } from '../../actions/fetch-following';
import { CLEAR_FOLLOWING } from '../../actions/clear-following';

export default function followingIdListReducer(state = [], action) {
  switch (action.type) {
    case FETCH_FOLLOWING_SUCCESS:
      return [...state, ..._.map(action.payload.following, follower => follower._id)];
    case CLEAR_FOLLOWING:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/following/id-list.js